import React, { useState } from 'react';
import './WinInputItem.css'
import { today } from '../util';
import { WinInputItemProps } from '../types';
import closeIcon from '../assets/close-icon.png';

const WinInputItem: React.FC<WinInputItemProps> = ({setDisplayNewBlankItem, addWinItem}) => {
  const [content, setContent] = useState('');

  const submitWinAction = () => {
    setDisplayNewBlankItem(false);
    addWinItem({content: content, date: today()})
  }

  const closeButtonClick = () => {
    setDisplayNewBlankItem(false);
  };

  return (
    <div className='win-input-item'>
      <div className='win-input-item-button-container'>
        <div className='win-item-close-container' onClick={e => closeButtonClick()}>
          <img src={closeIcon} alt='Edit Icon' />
        </div>
      </div>
      <input 
        className='win-input-field' 
        placeholder='What have you accomplished today?' 
        autoFocus={true} 
        value={content}
        onChange={(e) => setContent(e.target.value)} />
      <div className='submit-win-button' onClick={(e) => submitWinAction()}>ADD</div>
    </div>
  );
};

export default WinInputItem;
